const PRODUCT_SERVICE_MATCH_THRESHOLD = 0.5;
const TAX_RATE_MATCH_TOLERANCE = 0.005;

function bigrams(str) {
    const normalized = str.toLowerCase().trim();
    const result = [];

    for (let i = 0; i < normalized.length - 1; i++) {
        result.push(normalized.slice(i, i + 2));
    }

    return result;
}

export function similarityRatio(a, b) {
    if (!a || !b) {
        return 0;
    }

    const bigramsA = bigrams(a);
    const bigramsB = bigrams(b);

    if (bigramsA.length === 0 || bigramsB.length === 0) {
        return a.toLowerCase().trim() === b.toLowerCase().trim() ? 1 : 0;
    }

    const bigramsBCopy = [...bigramsB];
    let matches = 0;

    bigramsA.forEach((bigram) => {
        const index = bigramsBCopy.indexOf(bigram);
        if (index !== -1) {
            matches++;
            bigramsBCopy.splice(index, 1);
        }
    });

    return (2 * matches) / (bigramsA.length + bigramsB.length);
}

export function matchProductServiceCandidate(extractedText, candidates) {
    if (!candidates || candidates.length === 0) {
        return null;
    }

    let best = null;
    let bestScore = 0;

    candidates.forEach((candidate) => {
        const score = similarityRatio(extractedText, candidate.ProductService);
        if (score > bestScore) {
            bestScore = score;
            best = candidate;
        }
    });

    return bestScore >= PRODUCT_SERVICE_MATCH_THRESHOLD ? best : null;
}

export function matchTaxRateCandidate(taxAmount, amount, candidates) {
    if (!amount || amount <= 0 || !candidates || candidates.length === 0) {
        return null;
    }

    const derivedMultiplier = 1 + (taxAmount / amount);

    let best = null;
    let bestDiff = Infinity;

    candidates.forEach((candidate) => {
        const diff = Math.abs(candidate.Amount - derivedMultiplier);
        if (diff < bestDiff) {
            bestDiff = diff;
            best = candidate;
        }
    });

    return bestDiff <= TAX_RATE_MATCH_TOLERANCE ? best : null;
}
